import { Tour } from '@/api/models';
import OptionPicker from '@/common/OptionPicker/OptionPicker';
import styles from './AccountsSelect.module.scss';

export const ALL_ACCOUNTS_KEY = 'All Accounts';
const ALL_ACCOUNTS = [{ label: ALL_ACCOUNTS_KEY, value: ALL_ACCOUNTS_KEY }];

interface IAccountSelectProps {
  accounts: Tour[];
  defaultValue: string | null;
  // eslint-disable-next-line no-unused-vars
  handleSelectedAccount: (value: string) => void;
  className?: string;
}

function AccountsSelect({ accounts, defaultValue, handleSelectedAccount, className = '' }: IAccountSelectProps) {
  const options = ALL_ACCOUNTS.concat(accounts.map((account) => ({ label: account.name, value: account.name })));

  return (
    <OptionPicker
      title="Filter by Account"
      options={options}
      defaultValue={defaultValue || ALL_ACCOUNTS_KEY}
      onChange={handleSelectedAccount}
      className={className}
      modalClassName={styles.modalWidth}
    />
  );
}

export default AccountsSelect;
